import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';
import { get_query, getControlMeasureAssessment, getControlMeasures } from '../stateManagement/data';

import { get, post } from "../fetchers/fetchers";

import { useParams } from "react-router";

import {
    Accordion,
    AccordionSummary,
    Checkbox,
    Chip,
    FormControl,
    Grid, makeStyles, MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from "@material-ui/core";
import {
    AdequacyTypeID,
    IAdequacy,
    IAssessmentSettings,
    IControlMeasure,
    IControlMeasureAdequacy,
    IControlMeasureAssessment,
    IControlMeasureCost,
    IControlMeasureFailureMode,
    IControlType,
    ICriticalHazards,
    IFailureModeAssessment,
    IHarm,
    IProjectFailureMode
} from "../types/types";
import { CameraSharp, ExpandMore } from "@material-ui/icons";
import WarningIcon from '@material-ui/icons/Warning';
import { Consequence } from "./harm";
import { Confidence } from "./critical_failure_mode";
import { ControlAssessment } from "./control_measure_adequacy";
import ReasonablyPracticableTest from "./reasonably_practicable_test";
import ReasonablyPracticableSummary from "./reasonably_practicable_summary";
import { API_URL, APPLICATION } from "../env";
import { ControlConcern } from './societal_concern';
import { render_likelihood_pill } from './likelihood';
import { CostAdequacy, order_of_mag } from './control_measure_cost';
import ControlMeasureAssessmentRow from './rp_control_measure_row';
import { FormattedInput } from '@h-a-r-c/react-formatted-input';


interface IControlMeasureAssessmentsProps {
    existing: boolean
}

interface IRouteParams {
    id: string
}

const useStyles = makeStyles((theme) => ({
    button: {
        display: 'block',
        marginTop: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 300,
        maxWidth: 400,
        whiteSpace: "normal",
        fontSize: 14,
    },
    menu: {
        width: 200,
        whiteSpace: "normal",
        fontSize: 14,
    },
    listItem: {
        whiteSpace: "normal",
        fontSize: 14,


    }
}));



export const WarningChip = (name: string, inital_level?: number, tool_tip_label?: string) => {

    let level = -1;
    if (inital_level) {
        level = inital_level;
    }
    let alpha = 1
    let color = "#535353"
    let bcolor = "rgb(196,196,196)";
    if (level) {
        if (level === 4) {
            bcolor = "rgba(0,176,80," + alpha + ")";
            color = "rgb(0,0,0)";

        }
        if (level === 3) {
            bcolor = "rgba(206,238,208," + alpha + ")";
            color = "rgb(48,104,33)";

        }
        if (level === 2) {
            bcolor = "rgba(252,236,166," + alpha + ")";
            color = "rgb(152,96,34)";

        }
        if (level === 1) {
            bcolor = "rgba(251,84,81," + alpha + ")";
            color = "rgb(104,4,0)";

        }

    }


    if (tool_tip_label === undefined) {
        tool_tip_label = "Not enough data for assessment"
    }


    return (
        <div>
            <Tooltip title={tool_tip_label}>
                <Chip
                    icon={<WarningIcon />}
                    size="small"
                    label={name}
                    color="primary"
                    style={{ backgroundColor: bcolor, color: color }}
                />
            </Tooltip>
        </div>
    )
}


const RPControlMeasure: FC<IControlMeasureAssessmentsProps> = ({ existing }) => {
    const classes = useStyles();

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()

    const [isLoaded, setIsLoaded] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [controlTypes, setControlTypes] = useState<IControlType[]>([]);
    const [controlMeasures, setControlMeasures] = useState<IControlMeasure[]>([]);
    const [adequacies, setAdequacies] = useState<IAdequacy[]>([]);
    const [failureModes, setFailureModes] = useState<IProjectFailureMode[]>([]);
    const [controlMeasureAssessments, setControlMeasureAssessments] = useState<IControlMeasureAssessment[]>([]);
    const [controlMeasureFailureModes, setControlMeasureFailureModes] = useState<IControlMeasureFailureMode[]>([]);
    const [harms, setHarms] = useState<IHarm[]>([]);
    const [riskAssessments, setRiskAssessments] = useState<ICriticalHazards[]>([]);
    const [controlMeasureAdequacies, setControlMeasureAdequacies] = useState<IControlMeasureAdequacy[]>([]);
    const [controlMeasureCosts, setControlMeasureCosts] = useState<IControlMeasureCost[]>([]);
    //const [reloadControlMeasures, setReloadControlMeasures] = useState<boolean>(false);
    const [failureModeAssessments, setFailureModeAssessments] = useState<IFailureModeAssessment[]>([]);
    const [controlMeasureConcerns, setControlMeasureConcerns] = useState<IControlMeasureAdequacy[]>([]);
    const [settings, setSettings] = useState<IAssessmentSettings>();

    const [write_access, setWriteAccess] = useState<boolean>(false);

    useEffect(() => {

        if (tasks.loaded) {

            setControlMeasures(tasks.controlMeasures)
            setFailureModes(tasks.failureModes)
            setControlMeasureFailureModes(tasks.failureModeControlMeasures)
            setFailureModeAssessments(tasks.failureModeAssessments)
            setAdequacies(tasks.adequacies)
            setControlTypes(tasks.controlTypes)
            setControlMeasureAssessments(tasks.controlMeasureAssessments)
            setControlMeasureCosts(tasks.controlMeasureCosts)
            setControlMeasureAdequacies(tasks.controlMeasureAdequacy)
            setControlMeasureConcerns(tasks.controlMeasureConcern);
            setRiskAssessments(tasks.criticalHazards)
            setHarms(tasks.harms)
            setSettings(tasks.assessmentSettings)
        }

    }, [tasks])

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks.write_access])


    const params = useParams<IRouteParams>()

    const setControlMeasureAssessment = async (controlMeasureAssessment: IControlMeasureAssessment) => {
        delete controlMeasureAssessment.id
        return await post<IControlMeasureAssessment>(API_URL + "control_measures/" + params.id.toString() + "/assessments", controlMeasureAssessment);
    }


    const updateControlMeasureAssessmentFinal = useCallback((controlMeasureAssessment: IControlMeasureAssessment) => {
        //setReloadControlMeasures(true);
        setControlMeasureAssessment(controlMeasureAssessment).then(() => {
            getControlMeasureAssessment(params.id, dispatch)
        })
    }, []);

    const uploadControlMeasure = async (control_measure: IControlMeasure) => {
        let cm = { ...control_measure };
        delete cm.document;
        delete cm.id;
        
        // check if states in params
        let query_params = get_query()
        
        // check if state key in params
        if (query_params.state) {
            cm["state_id"] = parseInt(query_params.state)
        }
        const d = await post<IControlMeasure>(API_URL + "control_measures/" + params.id.toString() + "/", cm)
        getControlMeasures(params.id, dispatch)                

    }


    const getCMeasureCost = (cm: IControlMeasure): IControlMeasureCost => {
        let cm_id = cm.uuid
        if (!cm_id)
            cm_id = -1
        let controlMeasureCost = controlMeasureCosts.find(cma => cma.control_measure_id === cm_id)

        if (controlMeasureCost) {
            return controlMeasureCost
        }
        controlMeasureCost = {
            control_measure_id: cm_id
        }
        return controlMeasureCost
    }

    const overall_asessment = ["Reasonably Practicable",
        "Reasonably Practicable (tentative)",
        "Not Reasonably Practicable (tentative)",
        "Not Reasonably Practicable",
        "Cannot Determine at this Time"
    ]


    const getCMeasureAssessments = (cm: IControlMeasure): IControlMeasureAssessment[] => {

        let cm_id = cm.uuid
        if (!cm_id)
            cm_id = -1
        return controlMeasureAssessments.filter(cma => cma.control_measure_id === cm_id)

    }

    const [expanded, setExpanded] = React.useState<string | false>(false);

    const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const small_header = (f: IProjectFailureMode) => {

        let harm = harms.find(h => h.project_failure_mode_id === f.id);
        let critical_hazard = riskAssessments.find(h => h.project_failure_mode_id === f.id);
        let ec = controlMeasureAdequacies.find(a => a.project_failure_mode_id === f.id)
        let cc = controlMeasureConcerns.find(a => a.project_failure_mode_id === f.id)

        let considered = true


        return (
            <TableRow>
                <TableCell>{f.failure_mode?.name}</TableCell>
                <TableCell>
                    {critical_hazard ? render_likelihood_pill(critical_hazard.max_annual_failure_probability) : WarningChip("Likelihood")}
                </TableCell>
                <TableCell>
                    {considered ? harm ? Consequence(harm) : WarningChip("Harm") : ""}
                </TableCell>
                <TableCell>
                    {harm ? harm.special_consideration ? WarningChip(harm.special_consideration, harm.special_consideration === "None" ? -1 : 2, "Special Consideration") : "" : ""}
                </TableCell>
                { (APPLICATION === "ALARP" || settings?.consider_societal_concerns) && (
                    <TableCell>
                        {considered ? (cc ? ControlConcern(cc) : WarningChip("undefined")) : ""}
                    </TableCell>
                )}
                <TableCell>
                    {critical_hazard ? Confidence(critical_hazard, "societal_confidence_id",) : WarningChip("Societal Risk")}
                </TableCell>
                <TableCell>
                    {critical_hazard ? Confidence(critical_hazard, "individual_confidence_id",) : WarningChip("Individual Risk")}
                </TableCell>
                <TableCell>
                    {considered ? ec ? ControlAssessment(ec) : WarningChip("Improvement Opportunity") : ""}
                </TableCell>
            </TableRow>
        );
    }

    const checkControlMeasureProperty = (control_measure: IControlMeasure, property: keyof IControlMeasureAssessment) => {
        let cmas = getCMeasureAssessments(control_measure)
        return cmas.some((cma) => cma[property] === true)
    }





    const ControlMeasureItem = ({
        index,
        control_measure
    }: {
        index: number;
        control_measure: IControlMeasure;
    }) => {


        const [localControlMeasure, setLocalControlMeasure] = useState(control_measure);
        const control_measure_cost = getCMeasureCost(localControlMeasure);
        const [FMFilter, setFMFilter] = useState<number>(-1);


        const render_pill = (level: number, label: string, trigger: number) => {
            let color = "#535353";
            let alpha = FMFilter === trigger ? 1 : 0.1;
            let bcolor = "rgb(196,196,196," + alpha + ")";

            if (level === 3) {
                bcolor = "rgba(206,238,208," + alpha + ")";
                color = "rgb(48,104,33)";
            }
            if (level === 2) {
                bcolor = "rgba(206,238,208," + alpha + ")";
                color = "rgb(48,104,33)";
            }
            if (level === 1) {
                bcolor = "rgba(252,236,166," + alpha + ")";
                color = "rgb(152,96,34)";
            }
            if (level === 0) {
                bcolor = "rgba(251,84,81," + alpha + ")";
                color = "rgb(104,4,0)";
            }

            const chipStyle = {
                backgroundColor: bcolor,
                color: color,
                borderColor: color // Set the border color same as text color
            };

            return (
                <Tooltip title={label}>
                    <Chip
                        size="small"
                        label={label}
                        style={chipStyle}
                        onClick={() => setFMFilter(trigger)}
                        variant={FMFilter === trigger ? "default" : "outlined"}
                    />
                </Tooltip>
            );
        }      

        return (
            <Accordion style={{ backgroundColor: "#f3f3f3" }} expanded={expanded === 'panel' + index} onChange={handleChange('panel' + index)} square>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>

                    <Typography variant="h6"> {control_measure.description} </Typography>
                </AccordionSummary>


                <div style={{ position: 'sticky', top: 65, zIndex: 10, backgroundColor: "#f3f3f3" }}>

                    <Typography variant="h6"></Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        {render_pill(4, "All", -1)}
                        {render_pill(0, "Primary", 1)}
                        {render_pill(2, "Secondary", 2)}
                    </Grid>
                </Grid>


                    <Table>
                        <TableHead>
                            <TableCell><b>Failure Modes</b></TableCell>
                            <TableCell>Likelihood</TableCell>
                            <TableCell>Harm</TableCell>
                            <TableCell>Special Consideration</TableCell>
                            { ( APPLICATION == "ALARP" || settings?.consider_societal_concerns )&& 
                            <TableCell>Societal Concern</TableCell>}
                            <TableCell width={30}>Societal Risk</TableCell>
                            <TableCell width={30}>Individual Risk</TableCell>
                            <TableCell width={30}>Improvement Opportunity</TableCell>
                        </TableHead>

                        {get_failure_modes(control_measure, FMFilter).map((fm) => {
                            
                            return (
                                small_header(fm)
                            )
                        })}
                    </Table>

                    <Grid container xs={12} lg={12} style={{ padding: 15, width: "100%" }}>


                        <Grid item xs={3}>

                            <Typography style={{ fontWeight: 'bold', textAlign: 'left', fontSize: '14px' }}> {control_measure.description} </Typography>
                        </Grid>

                        <Grid item xs={9} lg={9} style={{ padding: 15, width: "100%" }}>
                            <TextField
                InputProps={{
                    style: { fontSize: '11pt'}}}
                                multiline
                                fullWidth
                                label="Description"
                                value={localControlMeasure.comment || ''}
                                onChange={(e) => setLocalControlMeasure({ ...localControlMeasure, comment: e.target.value })}
                                onBlur={() => uploadControlMeasure(localControlMeasure)}
                                disabled={!write_access}
                            />
                        </Grid>
                    </Grid>


                </div>


                <ControlMeasureAssessmentRow control_measure={control_measure} comment_id={0} write_access={true} control_measure_assessment={get_control_measure_assessment(control_measure)} control_measure_cost={control_measure_cost} updateControlMeasureAssessment={updateControlMeasureAssessmentFinal} />
            </Accordion>

        )
    }


    const get_control_measure_assessment = (control_measure: IControlMeasure) => {
        let cmas = getCMeasureAssessments(control_measure)
        let cma = cmas.find(cma => cma.project_failure_mode_id == -1)
        if (cma) {
            return cma
        }

        return {
            control_measure_id: control_measure.uuid,
            project_failure_mode_id: -1,

        }
    }

    const get_failure_modes = (control_measure: IControlMeasure, filter?:number) => {

        let cmas = getCMeasureAssessments(control_measure)
        let projectFailureModes: IProjectFailureMode[] = []

        cmas.map((cma) => {

            let f = controlMeasureFailureModes.find(cmf => cmf.control_measure_id === cma.control_measure_id && cmf.priority > 0 && cma.project_failure_mode_id === cmf.project_failure_mode_id)

            if (f) {
                let fm = failureModes.find(fm => fm.id === f?.project_failure_mode_id)

                if (fm) {
                   
                    if ( filter !== undefined) {
                        if ( filter !== -1) {
                            if( f.priority !== filter ) {
                                return
                        }
                    }
                    }
                    
                    if (fm.failure_mode?.is_active) {
                        projectFailureModes.push(fm)
                    }
                }
            }
            
        })

        return projectFailureModes

    }



    let filter_control_measures = controlMeasures.filter((cm) => {
        let cmas = getCMeasureAssessments(cm)

        if (cmas.length === 0) {
            return false
        }

        let pfs = get_failure_modes(cm)

        // check that cmas.project_failure_mode_id is in the pfms
        cmas = cmas.filter(cma => pfs.some(pf => pf.id === cma.project_failure_mode_id))

        // check that any of the failure modes is considered
        cmas = cmas.filter(cma => {
            let fma = failureModeAssessments.find(fma => fma.project_failure_mode_id === cma.project_failure_mode_id)
            if (!fma) {
                return false
            }
            return fma.consider === true
        })

        // check if any of the control measure assessments have a property set to true
        return cmas.some((cma) => cma.considered === true)
    })

    return (



        <Grid container xs={12} lg={12} style={{ padding: 10, width: "100%" }}>
            <Paper variant={"outlined"}

                style={{ display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1 }}>
                {isLoaded && filter_control_measures.filter((c) => c.existing === existing)
                    .map((cm, index) =>
                        <ControlMeasureItem key={cm.uuid} index={index} control_measure={cm} />

                    )}
                <div>
                    <Typography><small>Note only included control measures shown that address at least one priority failure mode</small></Typography>
                </div>
            </Paper>
        </Grid>


    );
}

export default RPControlMeasure;

